import { configureStore } from '@reduxjs/toolkit'
import cartReducer from './features/cart'
import couponReducer from './features/token'
import wishlistReducer from './features/wishlist'

export const makeStore = () => {
  return configureStore({
    reducer: {
      cart: cartReducer,
      coupon:couponReducer,
      wishlist:wishlistReducer
    },
  })
}

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']